// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__2l9WE","rotating":"Select_rotating__x37NS"};